import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import type { FranchiseFareDataParams } from './post-franchise-fare';

interface UpdatedDistrictValues {
  _id?: string;
  logFee?: number;
  deliveryValue?: number;
}

interface PutFranchiseFareParams {
  franchiseId: string | number;
  fareData: Omit<FranchiseFareDataParams, 'neighborhoods'> & {
    neighborhoods?: UpdatedDistrictValues[];
  };
}

const putFranchiseFare = async ({
  franchiseId,
  fareData,
}: PutFranchiseFareParams) =>
  apiClient
    .put(`/municipios/${franchiseId}`, fareData)
    .then(response =>
      handleResponseSuccess(
        response,
        'Tarifa do município atualizada com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível atualizar a tarifa do município.',
      ),
    );

export const usePutFranchiseFare = () => {
  return useMutation({
    mutationFn: putFranchiseFare,
  });
};
